import {Component, OnInit, OnDestroy} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {camelCase} from 'app/core/case-transform';
import {validate} from 'app/user/form.functions';

import {AuthService} from 'app/user/auth.service';

interface PasswordChange {
    token: string;
    password: string;
    confirmPassword: string;
}

@Component({
    selector: 'password-change',
    templateUrl: 'password-change.component.html',
    styleUrls: ['password-change.component.scss']
})
export class PasswordChangeComponent implements OnInit, OnDestroy {

    error: string;
    processing: boolean;
    submitted: boolean;
    subscriptions: Subscription[] = [];
    model: PasswordChange = {
        token: '',
        password: '',
        confirmPassword: ''
    };

    constructor(private _authService: AuthService,
                private _activatedRoute: ActivatedRoute,
                private _router: Router) {
    }

    ngOnInit(): void {
        const subscription = this._activatedRoute.params.subscribe(params => {
            this.model.token = params['token'];
        })
        this.subscriptions.push(subscription);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    validate(form: NgForm) {
        validate(form);
    }

    onHideError() {
        this.error = null;
    }

    onSubmit(form: NgForm) {
        if (form.invalid) {
            return;
        }

        this.error = null;
        this.processing = true;

        this._authService
                .changePassword(this.model.password, this.model.token)
                .subscribe(() => this._onSuccess(), error => this._onError(error));
    }

    onOk() {
        this.processing = true;
        this._router.navigateByUrl('/login');
    }

    private _onSuccess() {
        this.processing = false;
        this.submitted = true;
    }

    private _onError(response) {

        if (response.status === 404) {
            this.error = 'tokenExpired';
        }

        if (response.status === 400) {
            const responseJson = response.json();
            this.error = camelCase(responseJson.error);
        }

        this.processing = false;
    }
}